import { ProgressKind, RequestKind, boolean, string } from '@sb/library/base';
import { BatchPackagesMinutesUpdateItems, BatchResultItem, DisplayItemCollection, IErrorResponse, PackageDefinitionDisplayItem, PackageDefinitionInputItem, PackageDefinitionSearchOptions, PackageDefinitionUpdateItem, PackageMinutesDisplayItem, PackageMinutesInputItem, PackageMinutesSearchOptions, PackageMinutesUpdateItem, PackageSummaryDisplayItem, PackageSummarySearchOptions } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace PackagesRoutes {
    export namespace Definitions {
        export const Add = ApiRoute.Define({
            URL: 'packages/definitions',
            Kind: RequestKind.Post,
            BodyType: PackageDefinitionInputItem,
            ResultType: string
        });
        export const Search = ApiRoute.Define({
            URL: 'search/packages/definitions',
            Kind: RequestKind.Post,
            OrderByType: PackageDefinitionDisplayItem,
            PagingAllowed: true,
            BodyType: PackageDefinitionSearchOptions,
            ResultType: DisplayItemCollection<PackageDefinitionDisplayItem>
        });
        export const Update = ApiRoute.Define({
            URL: (packageDefinitionID: string) => `packages/definitions/${packageDefinitionID}`,
            Kind: RequestKind.Put,
            BodyType: PackageDefinitionUpdateItem,
            ResultType: boolean
        });
        export const Delete = ApiRoute.Define({
            URL: (packageDefinitionID: string) => `packages/definitions/${packageDefinitionID}`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });
    }
    export namespace Assignments {
        export const Add = ApiRoute.Define({
            URL: (packageDefinitionID: string, teacherID: string) => `teachers/${teacherID}/packagedefinitions/${packageDefinitionID}`,
            Kind: RequestKind.Post,
            ResultType: boolean
        });
        export const Delete = ApiRoute.Define({
            URL: (packageDefinitionID: string, teacherID: string) => `teachers/${teacherID}/packagedefinitions/${packageDefinitionID}`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });
    }
    export namespace Minutes {
        export const Get = ApiRoute.Define({
            URL: (packageMinutesID: string) => `packages/minutes/${packageMinutesID}`,
            Kind: RequestKind.Get,
            ResultType: PackageMinutesDisplayItem
        });
        export const Add = ApiRoute.Define({
            URL: 'packages/minutes',
            Kind: RequestKind.Post,
            BodyType: PackageMinutesInputItem,
            ResultType: string
        });
        export const Search = ApiRoute.Define({
            URL: 'search/packages/minutes',
            Kind: RequestKind.Post,
            OrderByType: PackageMinutesDisplayItem,
            PagingAllowed: true,
            BodyType: PackageMinutesSearchOptions,
            ResultType: DisplayItemCollection<PackageMinutesDisplayItem>
        });
        export const Update = ApiRoute.Define({
            URL: (packageMinutesID: string) => `packages/minutes/${packageMinutesID}`,
            Kind: RequestKind.Put,
            BodyType: PackageMinutesUpdateItem,
            ResultType: boolean
        });
        export const Delete = ApiRoute.Define({
            URL: (packageMinutesID: string) => `packages/minutes/${packageMinutesID}`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });
        export const BatchUpdate = ApiRoute.Define({
            URL: 'packages/minutes',
            Kind: RequestKind.Patch,
            BodyType: BatchPackagesMinutesUpdateItems,
            ResultType: Array<BatchResultItem<string, IErrorResponse>>,
            ShowProgress: ProgressKind.Computation
        });
    }
    export namespace Summary {
        export const Search = ApiRoute.Define({
            URL: 'summary/packages',
            Kind: RequestKind.Post,
            OrderByType: PackageSummaryDisplayItem,
            PagingAllowed: true,
            BodyType: PackageSummarySearchOptions,
            ResultType: DisplayItemCollection<PackageSummaryDisplayItem>
        });
    }
}
